import { setCookie, getCookie } from './site.js';


(function () {
    'use strict';

    // Konfiguracja i zmienne globalne modułu
    const szukajConfig = {
        urls: {},
        texts: {},
        initialState: {},
        configValues: {},
        elements: {}, // Elementy DOM będą dodawane dynamicznie
        messages: {}
    };
    let ajaxInProgress = false;

    // --- Funkcje pomocnicze ---

    function fadeElement(element, fadeIn, duration = 300, displayType = 'block') {
        if (!element) return;
        element.style.transition = `opacity ${duration}ms ease-in-out`;
        if (fadeIn) {
            element.style.opacity = '0';
            element.style.display = displayType;
            // Trigger reflow to apply initial state before transition
            element.offsetHeight;
            element.style.opacity = '1';
        } else {
            element.style.opacity = '0';
            setTimeout(() => {
                // Upewnij się, że element wciąż ma być ukryty przed zmianą display
                if (element.style.opacity === '0') element.style.display = 'none';
            }, duration);
        }
    }

    function showError(messageElement = szukajConfig.elements.errorInfoElement) {
        if (!messageElement) return;

        // Przewiń do elementu błędu, jeśli nie jest widoczny
        messageElement.scrollIntoView({behavior: "smooth", block: "center"});
        // Pokaż komunikat błędu
        messageElement.classList.add("show");
        // Ukryj po 2 sekundach
        setTimeout(() => messageElement.classList.remove("show"), 2000);
    }

    function hideErrorInfo() {
        const errorInfo = szukajConfig.elements.errorInfoElement;
        if (errorInfo) {
            errorInfo.classList.remove("show");
        }
    }

    function toggleClearButtonVisibility(input) {
        // Znajdź przycisk czyszczenia w tej samej grupie co input
        const clearBtn = input.parentElement?.querySelector(".filter-clear-button");
        if (clearBtn) clearBtn.style.display = input.value.length > 0 ? "block" : "none";
    }

    function clearFilterInput(button) {
        const input = button.parentElement?.querySelector(".filter-input");
        if (input) {
            input.value = "";
            button.style.display = "none"; // Ukryj przycisk czyszczenia
            input.focus(); // Ustaw focus na inpucie
            // Wywołaj event 'input', aby np. zaktualizować inne elementy UI
            input.dispatchEvent(new Event('input', {bubbles: true}));
            // Dodatkowo usuń klasę active z labelki, jeśli istnieje
            const label = input.parentElement?.querySelector(".filter-label");
            if (label) label.classList.remove('active');
        }
    }

    function preventNonNumeric(event) {
        // Zezwalaj na klawisze funkcyjne i nawigacyjne
        if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter", "Home", "End"].includes(event.key)) return;
        // Zablokuj inne klawisze niż cyfry (jeśli to pojedynczy znak)
        if (event.key.length === 1 && !/[0-9]/.test(event.key)) event.preventDefault();
    }

    function validateNumberInput(input, checkRange = false) { // Dodano parametr checkRange
        if (!input) return;
        const min = parseInt(input.min, 10);
        const max = parseInt(input.max, 10);
        const currentValue = input.value; // Zachowaj oryginalną wartość na chwilę

        // Sprawdź, czy wartość w ogóle jest poprawna wstępnie
        if (currentValue !== "" && isNaN(parseInt(currentValue, 10)) && currentValue !== '-') {
            input.value = "";
        } else if (checkRange && currentValue !== "") { // Sprawdzaj zakres tylko jeśli checkRange=true i nie jest puste
            let value = parseInt(currentValue, 10); // Parsuj dopiero tutaj

            if (!isNaN(value)) { // Jeśli jest faktycznie liczbą po sparsowaniu
                // Ogranicz wartość do min/max
                if (!isNaN(min) && value < min) input.value = min;
                else if (!isNaN(max) && value > max) input.value = max;
            } else {
                // Jeśli po parsowaniu wyszło NaN (np. wpisano samo '-'), wyczyść pole
                input.value = "";
            }
        }
        // Zaktualizuj widoczność przycisku czyszczenia
        toggleClearButtonVisibility(input);
    }

    function animateTextChange(element, newText, duration = 300) {
        if (!element) return;
        const halfDuration = duration / 2;
        // Faza zanikania
        element.style.transition = `opacity ${halfDuration}ms ease-out`;
        element.style.opacity = "0";
        // Po zaniknięciu zmień tekst i rozpocznij pojawianie się
        setTimeout(() => {
            element.textContent = newText;
            element.style.transition = `opacity ${halfDuration}ms ease-in`;
            element.style.opacity = "1";
        }, halfDuration);
    }

    function toggleMainInputLabel() {
        const label = szukajConfig.elements.mainInputLabel;
        const input = szukajConfig.elements.mainInput;

        if (label && input) {
            const hasValue = input.value.trim() !== "";
            // Zmień przezroczystość i klasę 'active' na podstawie wartości inputa
            label.style.opacity = hasValue ? "1" : "0";
            label.classList.toggle('active', hasValue);
        }
    }

    function toggleMainClearButton() {
        const input = szukajConfig.elements.mainInput;
        const clearButton = szukajConfig.elements.mainClearButton;
        if (input && clearButton) {
            // Pokaż przycisk tylko, gdy input ma wartość
            clearButton.style.visibility = input.value.trim() === '' ? 'hidden' : 'visible';
        }
    }

    function clearMainInput() {
        const input = szukajConfig.elements.mainInput;
        if (input) {
            input.value = ""; // Wyczyść wartość
            input.focus(); // Ustaw focus
            // Wywołaj eventy, aby zaktualizować UI (labelkę, przycisk czyszczenia)
            input.dispatchEvent(new Event('input', {bubbles: true}));
            input.dispatchEvent(new Event('blur', {bubbles: true})); // Symuluj blur, by labelka wróciła na miejsce
            input.focus(); // Ponownie ustaw focus dla wygody użytkownika
        }
    }

    function pleaseWaitShow() {
        const clearButton = szukajConfig.elements.mainClearButton;
        const progressInfo = szukajConfig.elements.progressInfo;
        // Ukryj przycisk czyszczenia, pokaż wskaźnik postępu
        if (clearButton) clearButton.style.visibility = 'hidden';
        if (progressInfo) progressInfo.style.display = 'block';
        ajaxInProgress = true; // Ustaw flagę trwającego żądania
    }

    function pleseWaitHide() { // Poprawka literówki w nazwie funkcji
        const progressInfo = szukajConfig.elements.progressInfo;
        // Opóźnij ukrycie wskaźnika i pokazanie przycisku, aby uniknąć migotania
        setTimeout(() => {
            toggleMainClearButton(); // Zaktualizuj widoczność przycisku czyszczenia
            if (progressInfo) progressInfo.style.display = 'none'; // Ukryj wskaźnik
            ajaxInProgress = false; // Zresetuj flagę żądania
        }, 300);
    }

    function PrzewinDoElementu(elementId, offset = 0) {
        const element = document.getElementById(elementId);
        if (element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY + offset;
            // Płynne przewinięcie do elementu z uwzględnieniem offsetu
            window.scrollTo({top: offsetPosition, behavior: 'smooth'});
        }
    }

    function adsRefresh() {
        if (!szukajConfig.configValues.adsenseShowAdsInResult) return; // Nie odświeżaj, jeśli reklamy są wyłączone
        try {
            // Spróbuj odświeżyć reklamy Google, jeśli biblioteka jest dostępna
            if (window.adsbygoogle && typeof window.adsbygoogle.push === "function") {
                window.adsbygoogle.push({});
            }
        } catch (e) {
            console.warn("Błąd odświeżania reklam:", e);
        }
    }

    // Prosta detekcja urządzeń mobilnych (można rozbudować)
    function isMobile() {
        return window.matchMedia("(max-width: 768px)").matches;
    }

    // Wysłanie zdarzenia do Google Analytics
    function gtagPush(url) {
        if (typeof gtag === 'function' && szukajConfig.configValues.gaCode) {
            // Wyślij page_view do głównego kodu GA
            gtag('config', szukajConfig.configValues.gaCode, {'page_path': url});
            // Wyślij page_view do dodatkowego kodu GA, jeśli istnieje
            if (szukajConfig.configValues.gaCodeAll) {
                gtag('config', szukajConfig.configValues.gaCodeAll, {'page_path': url});
            }
        } else {
            console.warn("Funkcja gtag nie znaleziona lub brak kodu GA.");
        }
    }

    // Funkcja obsługująca kliknięcie w wiersz
    function handleRowClick() {
        const href = this.dataset.href; // Pobierz URL z atrybutu data-href
        if (href) window.location.href = href; // Przejdź do URL
    }

    // Funkcja obsługująca naciśnięcie Enter na wierszu (dla dostępności)
    function handleRowKeydown(event) {
        if (event.key === "Enter") {
            const href = this.dataset.href;
            if (href) window.location.href = href;
        }
    }

    // Przypinanie listenerów do klikalnych wierszy
    function attachClickableRowListeners(containerElement) {
        if (!containerElement) return;
        containerElement.querySelectorAll(".clickable-row").forEach(row => {
            // Usuń stare listenery, aby uniknąć duplikacji po aktualizacji AJAX
            row.removeEventListener("click", handleRowClick);
            row.removeEventListener("keydown", handleRowKeydown);
            // Dodaj nowe listenery
            row.addEventListener("click", handleRowClick);
            row.addEventListener("keydown", handleRowKeydown);
            // Dodaj tabindex dla dostępności (możliwość focusowania klawiaturą)
            if (!row.hasAttribute('tabindex')) row.setAttribute('tabindex', '0');
        });
    }

    // Przełączanie widoczności filtrów (z animacją lub bez)
    function toggleFilters(instant = false) {
        const filtersDiv = szukajConfig.elements.filtersContainer;
        const toggleTextElement = szukajConfig.elements.filtersToggleText;
        const filtersEnabledField = szukajConfig.elements.filtersEnabledField;
        if (!filtersDiv || !toggleTextElement || !filtersEnabledField) return;

        const isCurrentlyVisible = filtersDiv.classList.contains("active");
        const duration = instant ? 0 : 500; // Czas trwania animacji

        // Ustaw styl transition (lub brak dla 'instant')
        filtersDiv.style.transition = instant ? 'none' : `max-height ${duration}ms ease-in-out, opacity ${duration}ms ease-in-out`;

        if (!isCurrentlyVisible) { // Pokaż filtry
            filtersDiv.style.display = 'block'; // Najpierw pokaż (dla obliczenia scrollHeight)
            const scrollHeight = filtersDiv.scrollHeight; // Pobierz pełną wysokość

            if (!instant) { // Animowane pokazanie
                filtersDiv.style.maxHeight = "0px"; // Start od zera
                filtersDiv.style.opacity = '0';
                filtersDiv.offsetHeight; // Wymuś reflow
                filtersDiv.style.maxHeight = `${scrollHeight}px`; // Animuj do pełnej wysokości
                filtersDiv.style.opacity = "1";
            } else { // Natychmiastowe pokazanie
                filtersDiv.style.maxHeight = `${scrollHeight}px`;
                filtersDiv.style.opacity = '1';
            }

            filtersDiv.classList.add("active"); // Oznacz jako aktywne
            const textToShow = szukajConfig.texts.hideFilters || "Ukryj filtry";
            // Zmień tekst przycisku (z animacją lub bez)
            if (!instant) animateTextChange(toggleTextElement, textToShow, duration / 1.5);
            else toggleTextElement.textContent = textToShow;
            filtersEnabledField.value = "true"; // Zaktualizuj ukryte pole

        } else { // Ukryj filtry
            const scrollHeight = filtersDiv.scrollHeight; // Pobierz aktualną wysokość

            if (!instant) { // Animowane ukrywanie
                filtersDiv.style.maxHeight = `${scrollHeight}px`;
                filtersDiv.offsetHeight; // Wymuś reflow
            }

            filtersDiv.style.maxHeight = "0px"; // Animuj do zera
            filtersDiv.style.opacity = "0";
            filtersDiv.classList.remove("active"); // Oznacz jako nieaktywne
            const textToShow = szukajConfig.texts.showFilters || "Pokaż filtry";
            // Zmień tekst przycisku (z animacją lub bez)
            if (!instant) animateTextChange(toggleTextElement, textToShow, duration / 1.5);
            else toggleTextElement.textContent = textToShow;
            filtersEnabledField.value = "false"; // Zaktualizuj ukryte pole

            // Ukryj element (display: none) po zakończeniu animacji
            if (!instant) {
                setTimeout(() => {
                    if (!filtersDiv.classList.contains("active")) filtersDiv.style.display = 'none';
                }, duration);
            } else {
                filtersDiv.style.display = 'none';
            }
        }

        // Przywróć domyślny transition po krótkiej chwili (jeśli było 'instant')
        if (instant) {
            setTimeout(() => {
                filtersDiv.style.transition = '';
            }, 50);
        }
    }

    // --- Obsługa kliknięcia przycisku "Pokaż szczegóły" ---
    function handleShowDetailsClick(event) {
        const button = event.currentTarget; // Przycisk, który został kliknięty
        const litery = button.dataset.litery; // Pobierz litery z atrybutu data-litery

        if (litery) {
            showDetails(litery); // Wywołaj funkcję ładowania szczegółów
        } else {
            console.warn("Nie znaleziono atrybutu 'data-litery' na przycisku szczegółów.");
        }
    }


    // --- Główna funkcja obsługi wysyłki formularza ---
    function handleSubmit(event) {
        event.preventDefault(); // Zatrzymaj domyślną wysyłkę formularza
        if (ajaxInProgress) return; // Nie wysyłaj, jeśli poprzednie żądanie trwa

        // Sprawdź, który przycisk zainicjował wysłanie
        const submitter = event.submitter;
        if (!submitter || !submitter.value) {
            console.warn("Submit bez wartości przycisku (submitter.value). Próba użycia domyślnego przycisku.");
            // Spróbuj zasymulować kliknięcie domyślnego przycisku (np. Szukaj)
            const defaultButton = szukajConfig.elements.buttonScrabbleSearch || szukajConfig.elements.buttonScrabbleWordIsCorrect;
            if (defaultButton) {
                // Użycie requestSubmit jest bezpieczniejsze i lepiej obsługuje walidację
                if (typeof szukajConfig.elements.form.requestSubmit === 'function') {
                    szukajConfig.elements.form.requestSubmit(defaultButton);
                } else {
                    defaultButton.click(); // Fallback dla starszych przeglądarek
                }
            } else {
                console.error("Nie można znaleźć domyślnego przycisku submit.");
            }
            return; // Zakończ, bo submit został obsłużony (lub wystąpił błąd)
        }
        const actionValue = parseInt(submitter.value, 10);

        // Zbierz dane z formularza
        const form = event.target;
        const formData = new FormData(form);
        const dataToSend = {
            Litery: formData.get('Litery') || '',
            FiltrowanieWlaczone: formData.get('FiltrowanieWlaczone')?.toLowerCase() === 'true',
            FiltrowanieZaczynaSieOd: formData.get('FiltrowanieZaczynaSieOd') || '',
            FiltrowanieKonczySieNa: formData.get('FiltrowanieKonczySieNa') || '',
            FiltrowanieZawiera: formData.get('FiltrowanieZawiera') || '',
            FiltowanieDlugosc: formData.get('FiltowanieDlugosc') ? parseInt(formData.get('FiltowanieDlugosc'), 10) : null,
            Akcja: actionValue,
            // DODANO: Odczyt wybranego słownika z ukrytego pola
            SelectedDictionaryIdTxt: szukajConfig.elements.selectedDictionaryInput?.value || 'all' // Domyślnie 'all' jeśli pole nie istnieje lub jest puste
        };

        // Walidacja pola długości
        const wordLengthInput = szukajConfig.elements.wordLengthInput;
        if (wordLengthInput && dataToSend.FiltowanieDlugosc !== null) {
            validateNumberInput(wordLengthInput, true); // Wymuś walidację zakresu
            // Odczytaj wartość ponownie po potencjalnej korekcie
            const correctedLength = wordLengthInput.value;
            dataToSend.FiltowanieDlugosc = correctedLength ? parseInt(correctedLength, 10) : null;
            if (isNaN(dataToSend.FiltowanieDlugosc)) dataToSend.FiltowanieDlugosc = null; // Zresetuj jeśli nadal błędna
        }


        // Walidacja - sprawdź, czy wymagane pola są wypełnione zależnie od akcji
        const saLitery = dataToSend.Litery.trim().length > 0;
        const saFiltry = dataToSend.FiltrowanieWlaczone && (
            dataToSend.FiltrowanieZaczynaSieOd ||
            dataToSend.FiltrowanieKonczySieNa ||
            dataToSend.FiltrowanieZawiera ||
            (dataToSend.FiltowanieDlugosc !== null && dataToSend.FiltowanieDlugosc > 0) // Upewnij się, że długość jest > 0
        );


        let valid = true;
        switch (dataToSend.Akcja) {
            case 1: // Np. akcja sprawdzająca poprawność słowa (np. buttonScrabbleWordIsCorrect)
                if (!saLitery) {
                    showError(); // Pokaż błąd, jeśli litery są puste
                    valid = false;
                }
                break;
            case 2: // Np. akcja szukania słów z liter (np. buttonScrabbleSearch)
                if (!saLitery && !saFiltry) {
                    showError(); // Pokaż błąd, jeśli ani litery ani filtry nie są podane
                    valid = false;
                }
                break;
            default:
                console.error("Nieznana akcja:", dataToSend.Akcja);
                valid = false;
        }
        if (!valid) return; // Przerwij, jeśli walidacja nie powiodła się

        // Pokaż wskaźnik ładowania
        pleaseWaitShow();

        // Wyślij żądanie AJAX (Fetch API)
        fetch(szukajConfig.urls.action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Tutaj można dodać token anty-CSRF, jeśli jest używany
                // 'RequestVerificationToken': '...'
            },
            body: JSON.stringify(dataToSend) // Przekonwertuj dane na JSON
        })
            .then(response => {
                // Sprawdź, czy odpowiedź serwera jest OK (status 2xx)
                if (response.ok) {
                    return response.json(); // Przetwórz odpowiedź jako JSON
                } else {
                    // Jeśli błąd, spróbuj odczytać treść błędu i rzuć wyjątek
                    return response.text().then(text => {
                        throw new Error(`Błąd ${response.status}: ${text}`)
                    });
                }
            })
            .then(data => {
                // Sprawdź, czy odpowiedź zawiera oczekiwane dane
                if (data && data.html !== undefined && data.title !== undefined && data.url !== undefined) {
                    const panel = document.getElementById("panel"); // Znajdź kontener na wyniki
                    if (panel) {
                        panel.innerHTML = data.html; // Wstaw nowy HTML z wynikami
                        attachClickableRowListeners(panel); // Ponownie podepnij listenery do klikalnych wierszy

                        // Podpięcie listenera do przycisku szczegółów (jeśli istnieje w nowym HTML)
                        const showDetailsButton = panel.querySelector("#show-details-button");
                        if (showDetailsButton) {
                            showDetailsButton.addEventListener('click', handleShowDetailsClick);
                        }

                    } else {
                        console.error("Element #panel nie został znaleziony do aktualizacji.");
                    }

                    // Zamknij klawiaturę na mobile po akcji
                    if (actionValue === 1 && isMobile()) { // Sprawdź słowo
                        if (szukajConfig.elements.buttonScrabbleWordIsCorrect) {
                            szukajConfig.elements.buttonScrabbleWordIsCorrect.focus();
                            szukajConfig.elements.buttonScrabbleWordIsCorrect.blur();
                        } else if (szukajConfig.elements.mainInput) {
                            szukajConfig.elements.mainInput.blur(); // Alternatywa
                        }
                    }

                    if (actionValue === 2 && isMobile()) { // Szukaj słów
                        if (szukajConfig.elements.buttonScrabbleSearch) {
                            szukajConfig.elements.buttonScrabbleSearch.focus();
                            szukajConfig.elements.buttonScrabbleSearch.blur();
                        } else if (szukajConfig.elements.mainInput) {
                            szukajConfig.elements.mainInput.blur(); // Alternatywa
                        }
                    }


                    // Zaktualizuj tytuł strony i historię przeglądarki
                    document.title = data.title;
                    history.pushState({searchState: true, url: data.url}, data.title, data.url);

                    // Wyślij zdarzenie do Google Analytics
                    gtagPush(data.url);
                    // Odśwież reklamy
                    adsRefresh();
                    PrzewinDoElementu("found-words-result", -8); // Przewiń do wyników

                } else {
                    // Rzuć błąd, jeśli odpowiedź serwera jest niekompletna
                    throw new Error("Niekompletna odpowiedź serwera (brak html, title lub url).");
                }
            })
            .catch(error => {
                // Obsługa błędów sieciowych lub błędów przetwarzania odpowiedzi
                console.error('Błąd fetch podczas wysyłki formularza:', error);
                alert(szukajConfig.messages.ajaxProblem || "Wystąpił problem podczas komunikacji z serwerem.");
            })
            .finally(() => {
                // Zawsze ukryj wskaźnik ładowania po zakończeniu żądania (sukces lub błąd)
                pleseWaitHide(); // Poprawiona nazwa funkcji
            });
    }

    // --- Funkcja ładowania szczegółów (AJAX GET) ---
    function showDetails(litery) {
        const detailsUrl = szukajConfig.urls.details;
        // Nie wykonuj, jeśli brak URL lub inne żądanie jest w toku
        if (!detailsUrl || ajaxInProgress) return;

        // Przygotuj URL z parametrem
        const urlWithParams = `${detailsUrl}?litery=${encodeURIComponent(litery)}`;
        const detailsDiv = document.getElementById('div-details'); // Kontener na szczegóły
        if (!detailsDiv) {
            console.error("#div-details nie znaleziono.");
            return;
        }

        // Pokaż wskaźnik ładowania
        pleaseWaitShow();

        // Wyślij żądanie AJAX (GET) po HTML
        fetch(urlWithParams, {
            method: 'GET',
            headers: {'Accept': 'text/html'} // Oczekujemy HTML
        })
            .then(response => {
                if (response.ok) {
                    return response.text(); // Zwróć HTML jako tekst
                } else {
                    return response.text().then(text => {
                        throw new Error(`Błąd ${response.status}: ${text}`)
                    });
                }
            })
            .then(html => {
                detailsDiv.innerHTML = html; // Wstaw otrzymany HTML do kontenera
                // Jeśli w załadowanym HTML są klikalne wiersze, podepnij listenery
                attachClickableRowListeners(detailsDiv);
                // Przewiń do załadowanych szczegółów
                PrzewinDoElementu('div-details', -20);
            })
            .catch(error => {
                console.error('Błąd ładowania szczegółów:', error);
                // Pokaż komunikat o błędzie w kontenerze szczegółów
                detailsDiv.innerHTML = '<p class="error">Wystąpił błąd podczas ładowania szczegółów.</p>';
            })
            .finally(() => {
                // Zawsze ukryj wskaźnik ładowania
                pleseWaitHide(); // Poprawiona nazwa funkcji
            });
    }

    // --- Funkcja: Inicjalizacja modala wyboru słownika ---

// --- Funkcja: Inicjalizacja modala wyboru słownika ---
    function initializeDictionaryModal() {
        console.log("Inicjalizacja modala słownika...");

        const {
            dictionaryModalButton,
            dictionaryModal,
            dictionaryModalBackdrop,
            selectedDictionaryInput,
            dictionaryModalCloseButton,
            dictionaryOptions // To będzie NodeList
        } = szukajConfig.elements;

        const buttonTextSpan = dictionaryModalButton?.querySelector('.dictionary-button-text');

        // Sprawdź, czy kluczowe elementy modala istnieją
        if (!dictionaryModalButton || !dictionaryModal || !dictionaryModalBackdrop || !selectedDictionaryInput || !buttonTextSpan || !dictionaryOptions || dictionaryOptions.length === 0) {
            console.warn('Nie znaleziono wszystkich kluczowych elementów modala słownika lub brak opcji. Modal nie zostanie zainicjowany.');
            if (dictionaryModalButton) dictionaryModalButton.style.display = 'none'; // Ukryj przycisk, jeśli modal nie działa
            return;
        }

        // --- Funkcja aktualizująca wybór ---
        const updateDictionarySelection = (selectedKey) => {
            // Znajdź domyślny opis dla 'all' na wypadek gdyby coś poszło nie tak
            const defaultAllOption = Array.from(dictionaryOptions).find(opt => opt.dataset.dictionaryKey === 'all');
            let selectedButtonHtml = defaultAllOption?.dataset.dictionaryDesc || 'All words'; // Domyślny HTML przycisku

            dictionaryOptions.forEach(opt => {
                const isSelected = opt.dataset.dictionaryKey === selectedKey;
                opt.classList.toggle('selected', isSelected);
                opt.setAttribute('aria-selected', isSelected.toString());

                // --- ZMIANA TUTAJ ---
                // Jeśli ta opcja jest wybrana, pobierz jej data-dictionary-desc
                if (isSelected) {
                    const descHtml = opt.dataset.dictionaryDesc;
                    if (descHtml) {
                        selectedButtonHtml = descHtml; // Użyj HTML z atrybutu
                    } else {
                        console.warn(`Brak atrybutu 'data-dictionary-desc' dla opcji z kluczem: ${selectedKey}`);
                        // Fallback na poprzednią logikę lub prosty tekst
                        if (selectedKey === 'all' || selectedKey === 'All') {
                            selectedButtonHtml = defaultAllOption?.dataset.dictionaryDesc || '<strong>all</strong> words';
                        } else {
                            selectedButtonHtml = `<strong>${selectedKey.toUpperCase()}</strong> dict`;
                        }
                    }
                }
                // --- KONIEC ZMIANY ---
            });

            // Zmień HTML wewnątrz przycisku (bez zmian)
            buttonTextSpan.innerHTML = selectedButtonHtml;

            // Zaktualizuj ukryte pole (bez zmian)
            selectedDictionaryInput.value = selectedKey;

            // Zapisz wybór w ciasteczku (bez zmian)

            setCookie('SelectedDictionaryId', selectedKey, 365);

        };

        // --- Logika ładowania z Ciasteczka (bez zmian) ---
        let initialDictionaryKey = null;

        initialDictionaryKey = getCookie('SelectedDictionaryId');

        if (initialDictionaryKey) {
            const isValidKey = Array.from(dictionaryOptions).some(opt => opt.dataset.dictionaryKey === initialDictionaryKey);

            if (isValidKey) {
                updateDictionarySelection(initialDictionaryKey);
            } else {
                console.warn(`Klucz '${initialDictionaryKey}' z ciasteczka nie pasuje do żadnej opcji. Używam domyślnego 'all'.`);
                updateDictionarySelection('all'); // Użyj domyślnego 'all'
            }
        } else {
            // Brak ciasteczka - użyj domyślnej opcji zaznaczonej w HTML lub 'all'
            const defaultOption = dictionaryModal.querySelector('.dictionary-option.selected') || dictionaryModal.querySelector('.dictionary-option[data-dictionary-key="all"]');
            const defaultKey = defaultOption ? defaultOption.dataset.dictionaryKey : 'all';
            updateDictionarySelection(defaultKey);
        }

        // --- Funkcje otwierania/zamykania modala (bez zmian) ---
        const openDictionaryModal = () => {
            dictionaryModalBackdrop.classList.add('active');
            dictionaryModal.classList.add('active');
            dictionaryModal.setAttribute('aria-hidden', 'false');
            const firstFocusableElement = dictionaryModal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (firstFocusableElement) firstFocusableElement.focus();
        };

        const closeDictionaryModal = () => {
            dictionaryModalBackdrop.classList.remove('active');
            dictionaryModal.classList.remove('active');
            dictionaryModal.setAttribute('aria-hidden', 'true');
            if (dictionaryModalButton) dictionaryModalButton.focus();
        };

        // --- Podpięcie zdarzeń (bez zmian) ---
        dictionaryModalButton.addEventListener('click', openDictionaryModal);

        if (dictionaryModalCloseButton) {
            dictionaryModalCloseButton.addEventListener('click', closeDictionaryModal);
        } else {
            console.warn("Nie znaleziono przycisku zamykania modala wewnątrz #dictionaryModal");
        }

        dictionaryModalBackdrop.addEventListener('click', (event) => {
            if (event.target === dictionaryModalBackdrop) {
                closeDictionaryModal();
            }
        });

        dictionaryOptions.forEach(option => {
            option.addEventListener('click', () => {
                const selectedKey = option.dataset.dictionaryKey;
                if (selectedKey) {
                    updateDictionarySelection(selectedKey);
                    setTimeout(closeDictionaryModal, 150);
                } else {
                    console.warn("Kliknięto opcję słownika bez atrybutu data-dictionary-key", option);
                }
            });
            option.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    const selectedKey = option.dataset.dictionaryKey;
                    if (selectedKey) {
                        updateDictionarySelection(selectedKey);
                        setTimeout(closeDictionaryModal, 150);
                    } else {
                        console.warn("Aktywowano opcję słownika bez atrybutu data-dictionary-key", option);
                    }
                }
            });
            if (!option.hasAttribute('tabindex')) {
                option.setAttribute('tabindex', '0');
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && dictionaryModal.classList.contains('active')) {
                closeDictionaryModal();
            }
        });

        console.log("Modal słownika zainicjalizowany pomyślnie.");

    } // --- Koniec initializeDictionaryModal ---

    // --- Inicjalizacja komponentu wyszukiwania ---
    function initializeSearchComponent() {
        const configElement = document.getElementById('szukaj-config');
        if (!configElement?.dataset) {
            console.error("Nie znaleziono elementu konfiguracyjnego #szukaj-config lub brak atrybutów data-*");
            return;
        }

        // Wczytaj konfigurację z atrybutów data-*
        szukajConfig.messages.ajaxProblem = configElement.dataset.messagesAjaxProblem;
        szukajConfig.urls.action = configElement.dataset.actionUrl;
        szukajConfig.urls.details = configElement.dataset.detailsUrl;
        szukajConfig.urls.site = configElement.dataset.siteUrl;
        szukajConfig.texts.showFilters = configElement.dataset.textShowFilters;
        szukajConfig.texts.hideFilters = configElement.dataset.textHideFilters;
        szukajConfig.initialState.filtersVisible = configElement.dataset.initialFiltersVisible === 'true';
        szukajConfig.initialState.scrollToAnchorOnLoad = configElement.dataset.scrollToAnchorOnLoad === 'true';
        szukajConfig.configValues.gaCode = configElement.dataset.gaCode;
        szukajConfig.configValues.gaCodeAll = configElement.dataset.gaCodeAll;
        szukajConfig.configValues.adsenseShowAdsInResult = configElement.dataset.adsenseShowAdsInResult?.toLowerCase() === 'true';

        // Znajdź kluczowe elementy DOM i zapisz referencje
        szukajConfig.elements.form = document.getElementById("form-search");
        szukajConfig.elements.mainInput = document.getElementById("search-input-text");
        szukajConfig.elements.mainInputLabel = szukajConfig.elements.form?.querySelector(".floating-label");
        szukajConfig.elements.mainClearButton = document.getElementById("search-clear-button");
        szukajConfig.elements.filtersToggleButton = document.getElementById("span-filters-toggle");
        szukajConfig.elements.filtersToggleText = document.getElementById("span-filters-toggle");
        szukajConfig.elements.filtersContainer = document.getElementById("filters-container");
        szukajConfig.elements.filtersEnabledField = document.getElementById("filtrowanieWlaczoneField");
        szukajConfig.elements.filterInputs = document.querySelectorAll(".filter-input");
        szukajConfig.elements.filterClearButtons = document.querySelectorAll(".filter-group .filter-clear-button");
        szukajConfig.elements.wordLengthInput = document.getElementById("word-length");
        szukajConfig.elements.errorInfoElement = szukajConfig.elements.form?.querySelector(".error-label");
        szukajConfig.elements.progressInfo = document.getElementById("progress-info");
        szukajConfig.elements.buttonScrabbleSearch = document.getElementById("button_scrabble_search");
        szukajConfig.elements.buttonScrabbleWordIsCorrect = document.getElementById("button_scrabble_word_is_correct");

        // Elementy dla modala słownika
        szukajConfig.elements.dictionaryModalButton = document.querySelector('.dictionary-button');
        szukajConfig.elements.dictionaryModal = document.getElementById('dictionaryModal');
        szukajConfig.elements.dictionaryModalBackdrop = document.getElementById('dictionaryModalBackdrop');
        szukajConfig.elements.selectedDictionaryInput = document.getElementById('selected-dictionary-key');
        szukajConfig.elements.dictionaryModalCloseButton = szukajConfig.elements.dictionaryModal?.querySelector('.dictionary-modal-close');
        szukajConfig.elements.dictionaryOptions = szukajConfig.elements.dictionaryModal?.querySelectorAll('.dictionary-option');


        // Sprawdź, czy kluczowe elementy formularza istnieją
        if (!szukajConfig.elements.form || !szukajConfig.elements.mainInput || !szukajConfig.elements.filtersContainer || !szukajConfig.elements.filtersEnabledField) {
            console.error("Brak kluczowych elementów formularza (form, search-input-text, filters-container, filtrowanieWlaczoneField). Inicjalizacja przerwana.");
            return;
        }

        console.log("Wartość #filtrowanieWlaczoneField po renderowaniu przez Razor:", szukajConfig.elements.filtersEnabledField?.value);

        // --- Ustawienie początkowego stanu UI ---
        toggleMainInputLabel();
        toggleMainClearButton();
        szukajConfig.elements.filterInputs.forEach(input => {
            toggleClearButtonVisibility(input);
            const label = input.parentElement?.querySelector(".filter-label");
            if (label && input.value !== '') label.classList.add('active');
        });
        if (szukajConfig.elements.wordLengthInput && szukajConfig.elements.wordLengthInput.value !== "") {
            validateNumberInput(szukajConfig.elements.wordLengthInput, true); // Waliduj zakres na starcie
            const label = szukajConfig.elements.wordLengthInput.parentElement?.querySelector(".filter-label");
            if (label) label.classList.add('active'); // Upewnij się, że label jest aktywny
        }

        // --- Przypisanie event listenerów ---
        szukajConfig.elements.form.addEventListener("submit", handleSubmit);
        szukajConfig.elements.form.addEventListener("keypress", (event) => {
            if (event.key === "Enter" && event.target.tagName === 'INPUT' && event.target.type !== 'submit') {
                event.preventDefault();
                const defaultSubmitButton = szukajConfig.elements.buttonScrabbleSearch ||
                    szukajConfig.elements.buttonScrabbleWordIsCorrect ||
                    szukajConfig.elements.form.querySelector('button[type="submit"]');
                if (defaultSubmitButton) {
                    if (typeof szukajConfig.elements.form.requestSubmit === 'function') {
                        szukajConfig.elements.form.requestSubmit(defaultSubmitButton);
                    } else {
                        defaultSubmitButton.click();
                    }
                }
            }
        });

        if (szukajConfig.elements.mainInput) {
            szukajConfig.elements.mainInput.addEventListener("input", () => {
                toggleMainInputLabel();
                toggleMainClearButton();
                hideErrorInfo();
            });
            szukajConfig.elements.mainInput.addEventListener("focus", toggleMainInputLabel);
            szukajConfig.elements.mainInput.addEventListener("blur", toggleMainInputLabel);
        }

        if (szukajConfig.elements.mainClearButton) {
            szukajConfig.elements.mainClearButton.addEventListener("click", clearMainInput);
        }

        if (szukajConfig.elements.filtersToggleButton) {
            szukajConfig.elements.filtersToggleButton.addEventListener("click", () => toggleFilters(false)); // false = z animacją
        }

        szukajConfig.elements.filterInputs.forEach(input => {
            if (input.id === 'word-length') return; // Obsługa poniżej
            input.addEventListener("input", () => toggleClearButtonVisibility(input));
            const label = input.parentElement?.querySelector(".filter-label");
            if (label) {
                input.addEventListener('focus', () => label.classList.add('active'));
                input.addEventListener('blur', () => {
                    if (input.value === '') label.classList.remove('active');
                });
                if (input.value !== '') label.classList.add('active');
            }
        });

        szukajConfig.elements.filterClearButtons.forEach(button => {
            button.addEventListener("click", () => clearFilterInput(button));
        });

        // Listenery dla wordLengthInput
        if (szukajConfig.elements.wordLengthInput) {
            szukajConfig.elements.wordLengthInput.addEventListener("keydown", preventNonNumeric);
            szukajConfig.elements.wordLengthInput.addEventListener("input", () => {
                validateNumberInput(szukajConfig.elements.wordLengthInput, false); // Tylko podstawowa walidacja i przycisk 'x'
                const label = szukajConfig.elements.wordLengthInput.parentElement?.querySelector(".filter-label");
                if (label) label.classList.toggle('active', szukajConfig.elements.wordLengthInput.value !== '');
            });
            szukajConfig.elements.wordLengthInput.addEventListener("blur", () => {
                validateNumberInput(szukajConfig.elements.wordLengthInput, true); // Pełna walidacja zakresu przy utracie focusa
                const label = szukajConfig.elements.wordLengthInput.parentElement?.querySelector(".filter-label");
                if (label) label.classList.toggle('active', szukajConfig.elements.wordLengthInput.value !== '');
            });
            const wordLengthLabel = szukajConfig.elements.wordLengthInput.parentElement?.querySelector(".filter-label");
            if (wordLengthLabel) {
                szukajConfig.elements.wordLengthInput.addEventListener('focus', () => wordLengthLabel.classList.add('active'));
                // Blur jest już obsłużony powyżej, ale upewnijmy się, że label jest aktywny na starcie jeśli jest wartość
                if (szukajConfig.elements.wordLengthInput.value !== '') wordLengthLabel.classList.add('active');
            }
        }

        // Podpięcie listenerów do klikalnych wierszy (jeśli są od razu załadowane)
        attachClickableRowListeners(document.getElementById("panel"));

        // Obsługa popstate (historia przeglądarki)
        window.addEventListener('popstate', (event) => {
            console.log("Zdarzenie Popstate:", window.location.href, event.state);
            // Prosta implementacja: przeładuj stronę, aby odtworzyć stan z URL
            // Dla bardziej zaawansowanych SPA można by tu ładować dane przez AJAX
            if (event.state && event.state.searchState) {
                console.log("Wykryto stan historii, przeładowuję stronę...");
                window.location.reload();
            } else {
                console.log("Popstate bez stanu lub stan nieznany.");
                // Można rozważyć inne działanie, np. powrót do strony głównej lub nic
            }
        });

        // Początkowe przewinięcie do kotwicy
        if (szukajConfig.initialState.scrollToAnchorOnLoad) {
            setTimeout(() => PrzewinDoElementu("search-anchor", -40), 150);
        }

        // Wywołanie inicjalizacji modala słownika
        initializeDictionaryModal();

        console.log("Komponent wyszukiwania zainicjalizowany.");

    } // --- Koniec initializeSearchComponent ---


    // --- Start inicjalizacji ---
    // Poczekaj na załadowanie DOM lub uruchom od razu, jeśli już załadowany
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSearchComponent);
    } else {
        initializeSearchComponent(); // DOM już gotowy
    }

})(); // Koniec IIFE (Immediately Invoked Function Expression)